import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import ImageRounded from "@mui/icons-material/ImageRounded";
import type { IconButtonProps } from "@mui/material";
import type { ChangeEvent, FC } from "react";
import { useCallback, useRef } from "react";
import { INSERT_IMAGE_FILES_COMMAND } from "../../types/commands";
import type { ToolbarProps } from "./props";
import { ToolbarIconButton } from "./toolbar-icon-button";

interface LocalImageButtonProps extends ToolbarProps, IconButtonProps {
  accept: string;
  label?: string;
  onClick: () => void;
}

export const LocalImageButton: FC<LocalImageButtonProps> = ({
  disabled,
  accept,
  label,
  onClick,
}) => {
  const [editor] = useLexicalComposerContext();
  const inputFile = useRef<HTMLInputElement>(null);

  const insertImage = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        editor.dispatchCommand(INSERT_IMAGE_FILES_COMMAND, {
          files: e.target.files,
        });
      }
      e.target.value = "";
      onClick();
    },
    [editor, onClick],
  );

  return (
    <>
      <ToolbarIconButton
        data-analytics-id="lexical-toolbar-image-upload"
        disabled={disabled}
        label={label}
        icon={<ImageRounded fontSize="medium" />}
        data-testid="toolbar-button-add-local-image"
        aria-label="add-image"
        tabIndex={-1}
        onClick={() => {
          inputFile?.current?.click();
        }}
      />
      <input
        ref={inputFile}
        type="file"
        accept={accept}
        id="local-image"
        style={{ display: "none" }}
        onChange={insertImage}
      />
    </>
  );
};
